import {configureStore, ThunkAction} from '@reduxjs/toolkit'
import rootReducer from './reducers'
import {AnyAction} from "redux";

// TODO: https://redux.js.org/recipes/configuring-your-store
export function configureAppStore(preloadedState?: any) {
    const store = configureStore({
      reducer: rootReducer,
      middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
      preloadedState
    })
  
    if (process.env.NODE_ENV !== 'production' && module.hot) {
      module.hot.accept('./reducers', () => store.replaceReducer(rootReducer))
    }
  
    return store
}

export const store = configureAppStore()
export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

export type AppThunk<ReturnType = void> = ThunkAction<
    ReturnType,
    RootState,
    unknown,
    AnyAction
>;